import $ from "jquery";
import Cleave from "cleave.js";
import moment from "moment-timezone";

import config from "js/config";
import item from "js/models/item";
import { REASON_FOR_LEAVING } from "lib/constants";
import { isLikelyContractJob } from "lib/util";
import wsStorage from "lib/wsStorage";

import { AddStep } from "./base";

const AddJobStep = AddStep.extend({
    ui: {
        current: "#current_job",
        contract: "#contract_job",
        city: "#city",
        state: "#state",
        company: "#company",
        title: "#title",
        start: "#start_date",
        end: "#end_date",
        startDateDesktop: "#start_date_selector",
        endDateDesktop: "#end_date_selector",
        startDateMobile: "#start_mobile_datepicker",
        endDateMobile: "#end_mobile_datepicker",
        duties: "#duties",
        reason: "#reason_for_leaving",
        reasonExplain: "#reason_explain",
        companyExplain: "#company_explain",
        companyExplainTag: ".company-explain",
        titleFlag: "#title-flag-missing",
        companyFlag: "#company-flag-missing",
        startDateFlag: "#start-date-flag-missing",
        endDateFlag: "#end-date-flag-missing",
        dutiesFlag: "#duties-flag-missing",
        cityFlag: "#city-flag-missing",
        stateFlag: "#state-flag-missing",
        reasonFlag: "#reason-flag-missing",
        headerFirst: ".app-history-modal__header--first",
        headerStandard: ".app-history-modal__header:not(.app-history-modal__header--first)",
    },
    events: {
        "click @ui.current": "onHideEndFields",
        "click @ui.contract": "onUpdateContractReason",
        "change @ui.reason": "showReasonExplain",
        "change @ui.company": "showCompanyExplain",
        "click #delete-job": "onDelete",
    },
    getPlace() {
        if (this.autocomplete) {
            return this.autocomplete.getPlace();
        }

        return null;
    },
    showCompanyExplain(e) {
        const value = e.target.value.toLowerCase().replace(/\s/g, "");
        // Temp agencies
        const matches = [
            "terra",
            "express",
            "randstad",
            "adecco",
            "laborready",
            "peopleready",
            "staffmark",
            "resourcestaffing",
            "laborworks",
            "aerotek",
            "depaul",
            "staffing",
            "labormax",
            "allstar",
            "cody",
            "resource",
            "remedy",
            "catapult",
            "pridestaff",
            "wonolo",
            "bluecrew",
            "instawork",
            "shiftgig",
            "opti",
        ].filter((o) => value.indexOf(o) > -1);
        if (matches.length) {
            $(this.ui.companyExplain).fadeIn();
            $(this.ui.companyExplainTag).fadeIn();
        } else {
            $(this.ui.companyExplain).fadeOut();
            $(this.ui.companyExplainTag).fadeOut();
        }
    },
    showReasonExplain() {
        const val = $(this.ui.reason).val();
        if (val == "7" || val == "8" || val == "9") {
            $(this.ui.reasonExplain).fadeIn();
        } else {
            $(this.ui.reasonExplain).fadeOut();
        }
    },
    onHideEndFields(e) {
        this.hideEndFields($(e.target).is(":checked"));
    },
    hideEndFields(checked) {
        const els = [
            $(this.ui.end).parent(),
            $(this.ui.reason).parent(),
            $(this.ui.reason).siblings(".section"),
        ];

        // .toggle() was getting out of sync
        if (checked) {
            els.forEach((e) => {
                e.fadeOut();
            });
            $(this.ui.reasonExplain).fadeOut();
        } else {
            els.forEach((e) => {
                e.fadeIn();
            });
            this.showReasonExplain();
        }

        $(this.ui.reason).closest(".help-block").html("").addClass("hidden");
        $(this.ui.end).closest(".help-block").html("").addClass("hidden");
    },
    onDelete(event) {
        event.preventDefault();
        this.model.destroy();
        this.trigger("modal:close");
    },
    onUpdateContractReason() {
        const reason = this.ui.contract.is(":checked") ? REASON_FOR_LEAVING.CONTRACT_ENDED : 0;
        if (!this.ui.current.is(":checked")) {
            this.ui.reason.val(reason);
        }
    },
    reset() {
        this.ui.duties[0].style.height = "";
        $(this.ui.end).parent().show();
        $(this.ui.reason).parent().show();
        $(this.ui.reason).siblings(".section").show();
        $(this.ui.current).prop("checked", false);
        $(this.ui.companyExplain).hide();
        $(this.ui.companyExplainTag).hide();
        $(this.ui.reasonExplain).hide();
        $(".job-in-form-warning-icon").hide();
        $(".help-block").hide();
        $(".has-error").removeClass("has-error");
    },
    addModel(_model) {
        this.model = _model || new item.Job();
    },
    fillCityStateFields() {
        const place = this.getPlace();
        if (!place || !place.address_components) {
            return false;
        }

        const addressFields = [
            [this.ui.city, ""],
            [this.ui.state, ""],
        ];

        place.address_components.forEach((addressComponent) => {
            const addressType = addressComponent.types[0];
            addressFields.forEach((addressField) => {
                const addressComponents = addressField[0].data("addressComponents");
                if (addressComponents.indexOf(addressType) > -1) {
                    addressField[1] += addressComponent.short_name;
                }
            });
        });

        addressFields.forEach((addressField) => {
            addressField[0].val(addressField[1]);
        });

        return true;
    },
    postRender() {
        if (this.model.get("first")) {
            this.model.unset("first");
            this.ui.headerFirst.show();
            this.ui.headerStandard.hide();
        } else {
            this.ui.headerFirst.hide();
            this.ui.headerStandard.show();
        }

        this.$el.removeClass("edit-mode");

        /* eslint-disable no-new */
        new Cleave(this.ui.startDateDesktop, config.cleave.SHORT_DATE_CONFIG);
        new Cleave(this.ui.endDateDesktop, config.cleave.SHORT_DATE_CONFIG);
        /* eslint-enable no-new */

        const address = this.ui.city[0];
        const onCityChange = this.fillCityStateFields.bind(this);
        // this is necessary in the case that we loadApplication directly
        if (window.loaded) {
            window.initCityAutocomplete(address, {
                onChange: onCityChange,
                callback: (ac) => (this.autocomplete = ac),
            });
        } else {
            $(window).on("load", () => {
                window.initCityAutocomplete(address, {
                    onChange: onCityChange,
                    callback: (ac) => (this.autocomplete = ac),
                });
            });
        }

        const data = this.model.toJSON();

        // current job will always exist for any imported resume job so use it for checking
        // if it is a job edit vs adding when resume was imported.
        const attemptedParse = wsStorage.getItem("attemptedResumeParse");
        if (data.title || (attemptedParse && typeof data.current_job !== "undefined")) {
            this.$el.addClass("edit-mode");
            this.ui.company.val(data.company);
            this.ui.title.val(data.title);
            this.ui.city.val(data.city);
            if (data.state) this.ui.state.val(data.state);
            this.ui.duties.val(data.duties);
            this.ui.current.prop("checked", data.current_job);
            // if contract_job property exists, default to that value
            // or compute whether input should be checked based on other conditions
            let contractJob = isLikelyContractJob(data);
            if (Object.prototype.hasOwnProperty.call(data, "contract_job")) {
                contractJob = data.contract_job;
            }
            this.ui.contract.prop("checked", contractJob);
            this.ui.startDateDesktop.val(data.start_date);
            this.ui.endDateDesktop.val(data.end_date);
            this.ui.startDateMobile.val(this.formatForDatePicker(data.start_date));
            this.ui.endDateMobile.val(this.formatForDatePicker(data.end_date));
            if (data.reason_for_leaving) {
                this.ui.reason.val(data.reason_for_leaving);
            } else if (contractJob && !data.current_job) {
                // default reason to contract ended for contract jobs
                this.ui.reason.val(REASON_FOR_LEAVING.CONTRACT_ENDED);
            }
            this.ui.reasonExplain.val(data.reason);

            if (data.current_job) {
                this.hideEndFields(true);
            }

            // if this job is missing fields then flag with error icon
            this.updateWarningForEdit(data);
        }
    },
    updateWarningForEdit(data) {
        this.ui.companyFlag.css("display", !data.company ? "flex" : "none");
        this.ui.titleFlag.css("display", !data.title ? "flex" : "none");
        this.ui.cityFlag.css("display", !data.city ? "flex" : "none");
        this.ui.stateFlag.css("display", !data.state || data.state === "XX" ? "flex" : "none");
        this.ui.dutiesFlag.css("display", !data.duties ? "flex" : "none");
        this.ui.reasonFlag.css(
            "display",
            !data.reason_for_leaving || data.reason_for_leaving === "0" ? "flex" : "none",
        );
        this.ui.startDateFlag.css(
            "display",
            !data.start_date || data.start_date.length <= 5 ? "flex" : "none",
        );
        this.ui.endDateFlag.css(
            "display",
            (!data.end_date || data.end_date.length <= 5) && !data.current_job ? "flex" : "none",
        );
    },
    getData() {
        const current = $(this.ui.current).is(":checked") ? 1 : 0;
        const contract = $(this.ui.contract).is(":checked") ? 1 : 0;

        let end = this.ui.endDateDesktop.val();
        if ($(this.ui.endDateMobile).is(":visible")) {
            end = this.reverseDatePicker(this.ui.endDateMobile.val());
        }

        if (current) {
            end = moment().format("MM/YYYY");
        }

        let start = this.ui.startDateDesktop.val();
        if ($(this.ui.startDateMobile).is(":visible")) {
            start = this.reverseDatePicker(this.ui.startDateMobile.val());
        }

        const data = {
            city: $(this.ui.city).val(),
            state: $(this.ui.state).val(),
            company: $(this.ui.company).val(),
            title: $(this.ui.title).val(),
            start_date: start,
            end_date: end,
            current_job: current,
            contract_job: contract,
            duties: $(this.ui.duties).val(),
            complete_data: true,
        };

        if (!current) {
            data.reason_for_leaving = $(this.ui.reason).val();
        }

        if ($(this.ui.reasonExplain).is(":visible")) {
            data.reason_explain = $(this.ui.reasonExplain).val();
        }

        if ($(this.ui.companyExplain).is(":visible")) {
            data.company_explain = $(this.ui.companyExplain).val();
        }

        this.updateWarningForEdit(data);

        return data;
    },
    reverseDatePicker(date) {
        if (!date) {
            return null;
        }
        const dateParts = date.split("-");
        return `${dateParts[1]}/${dateParts[0]}`;
    },
    formatForDatePicker(date) {
        if (!date) {
            return null;
        }
        const dateParts = date.split("/");
        return `${dateParts[1]}-${dateParts[0]}`;
    },
});

export default AddJobStep;
